<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <h1 class="page-title">Training</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current" >Training</span>
        </div>
    </div>

    <hr class="mb-1" />
    <div class="row mb-3">
        <div class="col-12">
            <button (click)="addNew()" class="mt-3 bg-accent-orange" mat-raised-button aria-label="add certification">
                <mat-icon>add</mat-icon> Add New Training
            </button>

        </div>
    </div>
    <div  style="overflow-x: auto;">
        <div class="table-responsive-dark list-wrapper-bordered-dark" >
            <table class="table table-striped table-hover table-bordered ">
                <thead>
                <tr>
                    <th class="text-nowrap">Title</th>
                    <th class="text-nowrap">Provider</th>
                    <th class="text-nowrap text-center">Attendance Type</th>
                    <th class="text-nowrap">Certification</th>
                    <th class="text-nowrap">Dates</th>
                    <th class="text-nowrap text-center">Cost</th>
                    <th class="text-nowrap">City</th>
                    <th class="text-nowrap">State</th>
                    <th class="text-nowrap">Training Type</th>
                    <th class="text-nowrap text-center">Status</th>
                    <th class="sticky-action"></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let ceu of ceus">
                    <td class="text-nowrap ellipsis" >{{ ceu.title }}</td>
                    <td class="text-nowrap" >{{ ceu.association?.providerName }}</td>
                    <td class="text-nowrap text-center" >{{maskingColumn('parameterLabel', 'parameterValue', attendanceTypeParams.parameterMembers, ceu.attendanceType)}}</td>
                    <td class="text-nowrap" >{{(ceu.certification)? ceu?.certification?.association?.providerName +' - '+ceu?.certification?.certificationTitle : '--'}}</td>
                    <td class="text-nowrap" >{{ceu.startDate | date : "MM/dd/y"}} to {{ceu.endDate | date : "MM/dd/y"}}</td>
                    <td class="text-nowrap text-center" >${{ceu.cost | number:'1.0-0'}}</td>
                    <td class="text-nowrap" >{{ceu.city}}</td>
                    <td class="text-nowrap" >{{ceu.stateOrProvince}}</td>
                    <td class="text-nowrap" >{{maskingColumn('parameterLabel', 'parameterValue', ceTypeParams.parameterMembers, ceu.ceType)}}</td>
                    <td class="text-nowrap text-center" >
                        <mat-icon *ngIf="ceu.active" class="accent-green" [matTooltip]="'Published'">task_alt</mat-icon>
                        <mat-icon *ngIf="!ceu.active" color="accent" [matTooltip]="'Unpublished'">unpublished</mat-icon>
                    </td>
                    <td class="sticky-action">
                        <div class="d-flex gap-4 justify-content-center">
                            <mat-icon class="accent-orange" (click)="editCeu(ceu)">edit</mat-icon>
                            <mat-icon class="crimson-red" (click)="deleteCeu(ceu)">delete</mat-icon>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="ceus.length == 0">
                    <td colspan="11" class="text-center">
                        <span>No Record</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="mt-4" *ngIf="ceus.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>


